// extracted by mini-css-extract-plugin
module.exports = {"timeLimitsTable":"_d8816c4"};